@if (!isLoaded) {
  <lin-spinner></lin-spinner>
}

@if (formError) {
  <div class="lin-form-error">{{ formError }}</div>
}

@if (isLoaded) {
  <form lin-layout-form [formGroup]="form" (ngSubmit)="saveData()">
    <lin-layout-form-sections-wrapper>
      <lin-layout-form-section layout="triple">
        <lin-form-label [required]="required.has('name')">{{ 'FIELDS.COMPANY_NAME' | translate }}:</lin-form-label>
        <mat-form-field color="accent">
          <input matInput formControlName="name" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="form.get('name')" controlName="name"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label [required]="required.has('legalName')">{{ 'FIELDS.LEGAL_NAME' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="legalName" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="form.get('legalName')" controlName="legalName"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label [required]="required.has('country')">{{ 'FIELDS.COUNTRY' | translate }}: </lin-form-label>
        <lin-improved-select
          controlName="country"
          optionValueKey="key"
          [required]="required.has('country')"
          [disabled]="form?.get('country')?.disabled"
          [hasSearch]="true"
          [staticSearch]="true"
          [staticList]="true"
          [selectedOption]="client?.country || ''"
          [preloadedOptions]="countries"
          [displayOptionLabel]="displayCountry"
          (selectOption)="handleCountrySelect($event.value)"
        ></lin-improved-select>

        <lin-form-label>{{ 'FIELDS.ABN' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="taxNr" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="form.get('taxNr')" controlName="taxNr"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        @if (showChevronAccountId) {
          <lin-form-label [required]="true">{{ 'FIELDS.chevronAccountId' | translate }}:</lin-form-label>
          <mat-form-field>
            <input matInput formControlName="chevronAccountId" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="form.get('chevronAccountId')" controlName="chevronAccountId"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        <lin-form-label [required]="required.has('legalAddress')">{{ 'FIELDS.LEGAL_ADDRESS' | translate }}:</lin-form-label>
        <mat-form-field>
          <textarea class="textarea" matInput rows="2" formControlName="legalAddress"></textarea>
          <mat-error>
            <lin-form-field-error [control]="form.get('legalAddress')" controlName="legalAddress"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label [required]="required.has('billingAddress')">{{ 'FIELDS.BILLING_ADDRESS' | translate }}:</lin-form-label>
        <mat-form-field>
          <textarea class="textarea" matInput rows="2" formControlName="billingAddress"></textarea>
          <mat-error>
            <lin-form-field-error [control]="form.get('billingAddress')" controlName="billingAddress"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        @if (client) {
          <lin-form-label [required]="required.has('accountingContact')">{{ 'FIELDS.ACCOUNTING_CONTACT' | translate }}: </lin-form-label>
          <mat-form-field>
            <mat-select formControlName="accountingContact" data-testid="select-accounting-contact">
              <mat-option value=""></mat-option>
              @for (user of users; track user.id) {
                <mat-option [value]="user.id">{{ user.fullName }}</mat-option>
              }
            </mat-select>
            <mat-icon svgIcon="mail_outline" (click)="sendEmail($event, 'accountingContact')" matSuffix></mat-icon>
            <mat-error>
              <lin-form-field-error [control]="form.get('accountingContact')" controlName="accountingContact"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        @if (client) {
          <lin-form-label [required]="required.has('keyContact')">{{ 'FIELDS.KEY_CONTACT' | translate }}:</lin-form-label>
          <mat-form-field>
            <mat-select formControlName="keyContact" data-testid="select-key-contact">
              <mat-option value=""></mat-option>
              @for (user of users; track user.id) {
                <mat-option [value]="user.id">{{ user.fullName }}</mat-option>
              }
            </mat-select>
            <mat-icon svgIcon="mail_outline" (click)="sendEmail($event, 'keyContact')" matSuffix></mat-icon>
            <mat-error>
              <lin-form-field-error [control]="form.get('keyContact')" controlName="keyContact"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        @if (settingsService.isXeroEnabled) {
          <label>{{ 'BILLING.XERO.XERO' | translate }}:</label>
          <lin-improved-select
            optionValueKey="contactId"
            requestSearchParamKey="searchTerm"
            requestPageParamKey="page"
            [disabled]="!user.isAdmin()"
            [hasSearch]="true"
            [selectedOption]="clientXeroContact?.contactId"
            [preloadedOptions]="xeroContacts"
            [pinnedOption]="clientXeroContact"
            [pinnedOptionValue]="clientXeroContact?.contactId"
            [pageSize]="100"
            [displayOptionLabel]="displayXeroContact"
            [getOptionsRequest]="getXeroContactsRequest"
            (selectOption)="handleXeroContactSelect($event.value)"
          ></lin-improved-select>
        }
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        @if (isStatusMode) {
          <lin-form-label [required]="required.has('status')">
            <span>{{ 'FIELDS.STATUS' | translate }}:</span>
            @if (client) {
              <a (click)="getStatusHistory()">{{ 'FIELDS.STATUS_INFO' | translate }}</a>
            }
          </lin-form-label>
          <mat-form-field>
            <mat-select formControlName="status" [disabled]="isBillingBlockedStatus(client?.status)" data-testid="select-status">
              @for (status of formStatuses; track status.name) {
                <mat-option [value]="status.name" [disabled]="isStatusDisabled(status.name)">
                  {{ 'MAIN.STATUS.' + status.name | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="form.get('status')" controlName="status"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        @if (form.value.status === 'demo') {
          <lin-form-label [required]="required.has('expirationDate')">{{ 'FIELDS.expirationDate' | translate }}:</lin-form-label>

          <lin-datepicker-field formControlName="expirationDate" [isPlaceholderShown]="true" [isNoMaxDate]="true"></lin-datepicker-field>
        }

        <lin-form-label [required]="required.has('plan')">{{ 'FIELDS.PLAN' | translate }}:</lin-form-label>
        <mat-form-field>
          <mat-select formControlName="plan" data-testid="select-plan">
            <mat-option [value]=""></mat-option>
            @for (plan of plans; track plan.id; let i = $index) {
              <mat-option [value]="plan.id">{{ plan.displayName }}</mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error [control]="form.get('plan')" controlName="plan"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        @if (isContractMonth) {
          <lin-form-label>
            <span>{{ 'FIELDS.CONTRACT' | translate }}:</span>
            @if (client && user.isAdminOrReseller()) {
              <a (click)="getContractHistory()">{{ 'ADMIN.CLIENTS.HISTORY' | translate }}</a>
            }
          </lin-form-label>
          <div class="contract">
            <mat-form-field color="accent" class="contract-months">
              <input matInput formControlName="contractMonths" autocomplete="off" type="number" min="0" max="999" />
            </mat-form-field>
            {{ 'FIELDS.MONTHS' | translate }}
          </div>
        }

        <lin-form-label>{{ 'FIELDS.SALES_REPRESENTATIVE' | translate }}:</lin-form-label>
        @if (user.isAdminOrReseller() && !isManager) {
          <mat-form-field>
            <mat-select formControlName="salesRepresentative" data-testid="select-sales-representative">
              <mat-option value=""></mat-option>
              @for (manager of salesRepresentatives; track manager.id) {
                <mat-option [value]="manager.id">{{ manager.fullName }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="form.get('salesRepresentative')" controlName="salesRepresentative"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        } @else {
          <mat-form-field>
            <input matInput formControlName="salesRepresentative" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="form.get('salesRepresentative')" controlName="salesRepresentative"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        <lin-form-label>{{ 'FIELDS.ACCOUNT_MANAGER' | translate }}:</lin-form-label>
        @if (user.isAdminOrReseller() && !isManager) {
          <mat-form-field>
            <mat-select formControlName="accountManager" data-testid="select-account-manager">
              <mat-option value=""></mat-option>
              @for (manager of accountManagers; track manager.id) {
                <mat-option [value]="manager.id">{{ manager.fullName }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="form.get('accountManager')" controlName="accountManager"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        } @else {
          <mat-form-field>
            <input matInput formControlName="accountManager" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="form.get('accountManager')" controlName="accountManager"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        <lin-form-label [required]="required.has('timezone')">{{ 'FIELDS.TIMEZONE' | translate }}:</lin-form-label>
        <mat-form-field>
          <lin-form-timezone-select formControlName="timezone" [timezones]="timezones"></lin-form-timezone-select>
          <mat-error>
            <lin-form-field-error [control]="form.get('timezone')" controlName="timezone"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-language-field [required]="required.has('language')" formControlName="language"></lin-language-field>
      </lin-layout-form-section>

      @if (clientId) {
        <lin-layout-form-section layout="triple">
          <div fxLayout="column" fxLayoutAlign="space-between stretch">
            <lin-note-list
              [isClient]="!!client"
              [notesHistory]="clientNotesHistory"
              (addNewNote)="addNote('client', $event)"
              (deleteNote)="deleteNote($event)"
            ></lin-note-list>

            @if (user.isAdmin()) {
              <lin-note-list
                [isClient]="!!client"
                [noteText]="'FIELDS.ADMIN_NOTE_TEXT' | translate"
                [notesHistory]="adminNotesHistory"
                (addNewNote)="addNote('admin', $event)"
                (deleteNote)="deleteNote($event)"
                [style.margin-top.px]="'15'"
              ></lin-note-list>
            }
          </div>
        </lin-layout-form-section>
      }
    </lin-layout-form-sections-wrapper>

    <lin-layout-form-toolbar>
      @if (!isEditMode) {
        <div></div>
      }
      @if (isEditMode) {
        <lin-form-submit-button [isDisabled]="!isEditMode" [isLoading]="isSubmitting" data-testid="btn-save">
          {{ 'BUTTONS.SAVE' | translate }}
        </lin-form-submit-button>
      }

      @if (client) {
        <lin-layout-form-toolbar-info>
          <lin-layout-form-toolbar-info-row>
            <lin-layout-form-toolbar-info-label>{{ 'MAIN.CREATED' | translate }}:</lin-layout-form-toolbar-info-label>
            <lin-layout-form-toolbar-info-value>
              {{ (client.createdAt | dayjsDateTime) || '-' }} {{ client.createdByName && ('ADMIN.CLIENTS.BY' | translate) }} {{
              client.createdByName }}
            </lin-layout-form-toolbar-info-value>
          </lin-layout-form-toolbar-info-row>

          <lin-layout-form-toolbar-info-row>
            <lin-layout-form-toolbar-info-label>{{ 'MAIN.LAST_UPDATED' | translate }}:</lin-layout-form-toolbar-info-label>
            <lin-layout-form-toolbar-info-value>
              {{ (client.updatedAt | dayjsDateTime) || '-' }} {{ client.updatedBy && ('ADMIN.CLIENTS.BY' | translate) }} {{
              client.updatedBy?.fullName }}
            </lin-layout-form-toolbar-info-value>
          </lin-layout-form-toolbar-info-row>
        </lin-layout-form-toolbar-info>
      }
    </lin-layout-form-toolbar>
  </form>
}
